import { html, TemplateResult } from "lit";
import { customElement } from "lit/decorators.js";
import { Engine, Entity } from "../engine/Engine";
import { SmoothOrbitController } from "./SmoothOrbitController";
import { SugarElement } from "./SugarCanvas";

@customElement("smooth-orbit")
export class SmoothOrbitElement extends SugarElement {
  protected override renderHtml(): TemplateResult {
    return html``;
  }

  createEntity(): Entity | undefined {
    return new SmoothOrbitController(
      Engine.activeEngine?.activeCamera?.controller
    );
  }
}
